window.useSPineOld = false
// if (window.useSPineOld){
//     require('./SpineOld');
//     //require('./spine3_1_07');
// }else{
//     require('./Spine');
//     //require('./spine3_6_53');
// }
let UseCachePacks = [
    "packed/FoamBombItemAssets.pack",
    "packed/MiniOctopusItemAssets.pack",
    "packed/CannedFishItemAssets.pack",
    "packed/JamItemAssets.pack",
    "packed/CircusBallItemAssets.pack"
]
require('./Spine38');
require('./CCSkeleton');
require('./CCSkeletonAnimation');
// require('./CCSkeletonCanvasRenderCmd');
require('./CCSkeletonWebGLRenderCmd');

window.UseCachePacksMap = {}
try {
    for(let v of UseCachePacks){
        let packs = ResManager.getPackConfig(v)
        for (let v of packs){
            if (v.indexOf(".skel") >= 0){
                window.UseCachePacksMap[v] = true
            }
        }
       
    }
} catch (error) {
    
}

console.log("spinecache window.UseCachePacksMap",  window.UseCachePacksMap )